import {Alert, Button, Col, Container, GoBack, Icon, Row, Table} from "design-react-kit";
import React, {useEffect, useMemo, useState} from "react";
import {properties} from "../../../config/properties";
import {useLocation, useNavigate} from "react-router-dom";
import Spinner from "../../layout/Spinner";


const styles = {

    tableContainer: {
        resize: "vertical",
        minHeight: "20vh",
        height: "60vh",
        maxHeight: "max-content",
        overflowY: "auto",
    },
    tableHeader: {
        borderBottom: "2px solid #dee2e6",
        backgroundColor: "#06c",
        color: "white",
        textTransform: "uppercase",
        fontWeight: 600,
        fontSize: "1.25rem",
        letterSpacing: "0.05em",
        position: "sticky",
        top: 0,
        zIndex: 1,
    },
    tableRowText: {
        color: "#333",
        fontWeight: 500,
        fontSize: "1rem",
        verticalAlign: "middle",
        textAlign: "left",
    },
    actionButton: {
        background: 'transparent',
        border: 'none',
        cursor: 'pointer',
        padding: '0.5rem'
    },
    fieldLabel: {
        color: '#333', // Grigio scuro per leggibilità
        fontSize: '0.875rem',
        marginBottom: '0.25rem',
    },
    fieldValue: {
        fontWeight: '600',
        marginBottom: '1.25rem',
        wordBreak: 'break-word',
    },
};

const InserimentoDeleghePersona = ({user}) => {

    const [data, setData] = useState([]);

    const [dataInizio, setDataInizio] = useState(() => {
        const today = new Date();
        return today.toISOString().split('T')[0]; // "YYYY-MM-DD"
    });

    const [dataFine, setDataFine] = useState(null);

    const location = useLocation();
    const { idProfilo } = location.state || {};
    const { nomeProfilo } = location.state || {};
    const { cognomeProfilo } = location.state || {};
    const navigate = useNavigate();

    const [selectedRows, setSelectedRows] = useState({});

    const hasSelections = useMemo(() => {
        return Object.values(selectedRows).some(Boolean);
    }, [selectedRows]);

    const [alert, setAlert] = useState({ visible: false, type: '', message: '' });

    const [loadingUser, setLoadingUser] = useState(true);


    const handleSubmitSelezionati = async (e) => {

        e.preventDefault();

        const righeSelezionate = data.filter(row => selectedRows[row.id]);

        if (righeSelezionate.length === 0) {
            setAlert({ visible: true, type: 'warning', message: 'Nessuna riga selezionata.' });
            return;
        }

        const deleghe = righeSelezionate.map(row => ({
            idDelega: row?.id
        }));

        const payload = {
            idPersona : idProfilo,
            dataInizio : dataInizio,
            dataFine : dataFine,
            idDeleghe : deleghe,
            userID: user.userID,
            cciaa: user.cciaa,
            gruppoUtente:user.gruppoUtente
        }


        try {
            const response = await fetch(
                `${properties.fullBaseUrl}${properties.baseAppUrl}/std/service/add/personaDelega`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(payload)
                }
            );

            if(response.status === 401){

                const datasResponse = await response.json();

                setAlert({visible: true, type: 'danger', message: 'Errore di comunicazione con il server.'});
                window.scrollTo({top: 0, behavior: 'smooth'});

                setTimeout(() => {
                    window.location.href = datasResponse.redirectUrl;
                }, 10);

                return;

            }

            const json = await response.json();

            navigate( '/private/gestioneDeleghePersona', { state: { esito: json , idProfilo : idProfilo, nomeProfilo : nomeProfilo , cognomeProfilo : cognomeProfilo } });

        } catch (error) {

            const json = {

                esito : "KO",
                messaggio: "Errore del server."
            }

            navigate( '/private/gestioneDeleghePersona', { state: { esito: json , idProfilo : idProfilo, nomeProfilo : nomeProfilo , cognomeProfilo : cognomeProfilo } });
        }
    };

    async function getDeleghe(requestData) {
        try {

            setLoadingUser(true);

            const res = await fetch(
                `${properties.fullBaseUrl}${properties.baseAppUrl}/std/service/list/delegheDisponibiliPersona`,
                {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(requestData),
                }
            );

            if(res.status === 401){

                const datasResponse = await res.json();

                setAlert({visible: true, type: 'danger', message: 'Errore di comunicazione con il server.'});
                window.scrollTo({top: 0, behavior: 'smooth'});

                setTimeout(() => {
                    window.location.href = datasResponse.redirectUrl;
                }, 10);

                return[];

            }

            if (!res.ok) throw new Error("Errore HTTP");
            const json = await res.json();
            return json.datiDeleghe || [];
        } catch (e) {
            console.error("Errore fetch:", e);
            return [];
        }finally {
            setLoadingUser(false);
        }
    }


    useEffect(() => {
        const fetchData = async () => {
            const requestPayload = { idProfilo : idProfilo, userID: user.userID, cciaa: user.cciaa, gruppoUtente:user.gruppoUtente };
            const deleghe = await getDeleghe(requestPayload);
            setData(deleghe);
        };
        fetchData();
    }, []);

    if (loadingUser) {
        // Puoi mostrare uno spinner o scritta di caricamento
        return (
            <Container fluid className="vh-100 d-flex justify-content-center align-items-center bg-light">
                <p className="mb-3">
                    <strong>
                        Caricamento
                    </strong>
                </p>
                <Spinner active/>
            </Container>
        );
    }

    return(


        <Container className={"py-lg-5"}>

            <div className={"pb-5"}>

                <h2>Assegna deleghe all'utente : {nomeProfilo} {cognomeProfilo}</h2>

                <div className={"text-end"}>
                    <Button
                        className={"btn btn-outline-primary"}
                        onClick={() => {
                            navigate('/private/gestioneDeleghePersona', {
                                state: {
                                    idProfilo: idProfilo,
                                    nomeProfilo: nomeProfilo,
                                    cognomeProfilo: cognomeProfilo
                                }
                            });
                        }}
                    >
                        Indietro
                    </Button>
                </div>

            </div>


            <Row className={"mb-5"}>


                <Col md={3}>

                    <form onSubmit={handleSubmitSelezionati}>

                        <div style={{
                            backgroundColor: "#f8f9fa", // grigio chiaro per evidenziare
                            padding: "1.5rem",
                            borderRadius: "8px",
                            border: "1px solid #dee2e6",
                        }}>
                            <div className="mb-3">
                            <label style={styles.fieldLabel}>Data Inizio</label>
                                {/* Qui puoi inserire l'input effettivo */}
                                <input
                                    type="date"
                                    className="form-control"
                                    value={dataInizio || ''}
                                    onChange={(e) => setDataInizio(e.target.value)}
                                    required
                                />
                            </div>

                            <div className="mb-4">
                                <label style={styles.fieldLabel}>Data Fine</label>
                                <input
                                    type="date"
                                    className="form-control"
                                    value={dataFine || ''}
                                    min={dataInizio}
                                    onChange={(e) => {
                                        const selectedDate = e.target.value;
                                        if (selectedDate >= dataInizio) {
                                            setDataFine(selectedDate);
                                        } else {
                                            setDataFine(''); // oppure potresti ignorare il set
                                        }
                                    }}
                                />
                            </div>

                            <div className={"pb-2"}>
                                <Button
                                    className={"btn btn-outline-primary"}
                                    disabled={!hasSelections}
                                >
                                    Assegna selezionati
                                </Button>
                            </div>
                        </div>

                    </form>

                </Col>


                <Col md={9}>

                    {alert.visible && (
                        <Alert color={alert.type} isOpen={alert.visible}
                               toggle={() => setAlert({...alert, visible: false})}>
                            {alert.message}
                        </Alert>
                    )}

                    <div style={styles.tableContainer}>
                        <Table  hover className="border-top-0">
                            <thead>
                            <tr >
                                <th scope="col" className="text-center" style={styles.tableHeader}>Seleziona</th>
                                <th scope="col" className="text-center" style={styles.tableHeader}>Descrizione delega</th>
                            </tr>
                            </thead>
                            <tbody>
                            {data.length > 0 ? (
                                data.map((row) => (
                                    <tr key={row.id}>
                                        <td>
                                            <input
                                                style={styles.tableRowText}
                                                className="form-check-input"
                                                type="checkbox"
                                                checked={selectedRows[row.id] || false}
                                                onChange={(e) => {
                                                    setSelectedRows((prev) => ({
                                                        ...prev,
                                                        [row.id]: e.target.checked,
                                                    }));
                                                }}
                                                aria-label={`Seleziona riga ${row.id}`}
                                            />

                                        </td>
                                        <td style={styles.tableRowText}>{row.descDelega}</td>

                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td
                                        className="text-center"
                                        style={styles.tableRowText}
                                        colSpan="7"
                                    >
                                        Non ci sono deleghe
                                    </td>
                                </tr>
                            )}
                            </tbody>
                        </Table>


                    </div>

                </Col>

            </Row>


        </Container>

    );


}
export default InserimentoDeleghePersona;